import GroupOptionsParticipantMessagingSelect from './GroupOptionsParticipantMessagingSelect';
import React from 'react';
import { isNil } from 'lodash';

const ParticipantMessagingSelectContainer = ({
  participantMessagingFromBackend,
  participantMessagingSchoolDefault,
  groupUuid,
  participantMessagingFromFrontend,
  setParticipantMessagingValue,
  disabled,
}: {
  participantMessagingFromBackend: string;
  participantMessagingSchoolDefault: string;
  groupUuid: string | null | undefined;
  participantMessagingFromFrontend: string | undefined | null;
  setParticipantMessagingValue: (participantMessagingValue: string) => void;
  disabled: boolean;
}) => {
  const participantMessaging = isNil(participantMessagingFromFrontend)
    ? participantMessagingFromBackend
    : participantMessagingFromFrontend;

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'setParticipantMessaging' implicitly has... Remove this comment to see the full error message
  const participantMessagingSelect = (setParticipantMessaging, participantMessagingValue) => {
    setParticipantMessaging({
      variables: {
        uuid: groupUuid,
        input: { participantMessagingState: participantMessagingValue },
      },
    });
    setParticipantMessagingValue(participantMessagingValue);
  };

  return (
    <GroupOptionsParticipantMessagingSelect
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
      groupUuid={groupUuid}
      participantMessagingSchoolDefault={participantMessagingSchoolDefault}
      participantMessaging={participantMessaging}
      participantMessagingSelect={participantMessagingSelect}
      disabled={disabled}
    />
  );
};

export default ParticipantMessagingSelectContainer;
